var map = {
	"./de/auth.json": [
		57082,
		7082
	],
	"./de/cluster.json": [
		70167,
		167
	],
	"./de/configmap.json": [
		28390,
		8390
	],
	"./de/crd.json": [
		37019,
		7019
	],
	"./de/frequent.json": [
		6432,
		6432
	],
	"./de/glossary.json": [
		92415,
		2415
	],
	"./de/hpa.json": [
		15039,
		5039
	],
	"./de/ingress.json": [
		61524,
		1524
	],
	"./de/logs.json": [
		75868,
		5868
	],
	"./de/node.json": [
		56239,
		6239
	],
	"./de/notifications.json": [
		19455,
		9455
	],
	"./de/pdb.json": [
		1613,
		1613
	],
	"./de/priorityClasses.json": [
		23555,
		3555
	],
	"./de/release.json": [
		39061,
		9061
	],
	"./de/resource.json": [
		5162,
		5162
	],
	"./de/resourceQuota.json": [
		45725,
		422
	],
	"./de/role.json": [
		50349,
		349
	],
	"./de/search.json": [
		2732,
		2732
	],
	"./de/settings.json": [
		50400,
		400
	],
	"./de/sidebar.json": [
		44522,
		4522
	],
	"./de/workload.json": [
		57522,
		7522
	],
	"./en/auth.json": [
		62723,
		2723
	],
	"./en/cluster.json": [
		34241,
		4241
	],
	"./en/configmap.json": [
		47076,
		7076
	],
	"./en/crd.json": [
		89577,
		9577
	],
	"./en/frequent.json": [
		79071,
		9071
	],
	"./en/glossary.json": [
		72501,
		2501
	],
	"./en/hpa.json": [
		36589,
		6589
	],
	"./en/ingress.json": [
		8667,
		8667
	],
	"./en/logs.json": [
		35697,
		5697
	],
	"./en/node.json": [
		52520,
		2520
	],
	"./en/notifications.json": [
		91191,
		1191
	],
	"./en/pdb.json": [
		49727,
		9727
	],
	"./en/priorityClasses.json": [
		27485,
		7485
	],
	"./en/release.json": [
		74562,
		4562
	],
	"./en/resource.json": [
		94524,
		4524
	],
	"./en/resourceQuota.json": [
		68182,
		8182
	],
	"./en/role.json": [
		85179,
		5179
	],
	"./en/search.json": [
		2480,
		2480
	],
	"./en/settings.json": [
		46841,
		6841
	],
	"./en/sidebar.json": [
		16099,
		6099
	],
	"./en/workload.json": [
		33168,
		3168
	],
	"./es/auth.json": [
		23545,
		3545
	],
	"./es/cluster.json": [
		24871,
		4871
	],
	"./es/configmap.json": [
		45339,
		5339
	],
	"./es/crd.json": [
		88270,
		8270
	],
	"./es/frequent.json": [
		26950,
		6950
	],
	"./es/glossary.json": [
		25976,
		5976
	],
	"./es/hpa.json": [
		78548,
		8548
	],
	"./es/ingress.json": [
		15416,
		5416
	],
	"./es/logs.json": [
		91156,
		1156
	],
	"./es/node.json": [
		75845,
		5845
	],
	"./es/notification.json": [
		79654,
		9654
	],
	"./es/notifications.json": [
		20217,
		217
	],
	"./es/pdb.json": [
		74454,
		4454
	],
	"./es/priorityClasses.json": [
		15578,
		5578
	],
	"./es/release.json": [
		13075,
		3075
	],
	"./es/resource.json": [
		42232,
		2232
	],
	"./es/resourceQuota.json": [
		42230,
		2230
	],
	"./es/role.json": [
		31121,
		1121
	],
	"./es/search.json": [
		94866,
		4866
	],
	"./es/settings.json": [
		22150,
		2150
	],
	"./es/sidebar.json": [
		98762,
		8762
	],
	"./es/workload.json": [
		49189,
		9189
	],
	"./fr/auth.json": [
		24047,
		4047
	],
	"./fr/cluster.json": [
		27396,
		7396
	],
	"./fr/configmap.json": [
		93616,
		3616
	],
	"./fr/crd.json": [
		96014,
		8470
	],
	"./fr/frequent.json": [
		13310,
		3310
	],
	"./fr/glossary.json": [
		25988,
		5988
	],
	"./fr/hpa.json": [
		48056,
		8056
	],
	"./fr/ingress.json": [
		28817,
		8817
	],
	"./fr/logs.json": [
		13483,
		3483
	],
	"./fr/node.json": [
		64867,
		4867
	],
	"./fr/notifications.json": [
		26619,
		6619
	],
	"./fr/pdb.json": [
		31138,
		1138
	],
	"./fr/priorityClasses.json": [
		73240,
		3240
	],
	"./fr/release.json": [
		32444,
		2444
	],
	"./fr/resource.json": [
		17093,
		7093
	],
	"./fr/resourceQuota.json": [
		16176,
		6176
	],
	"./fr/role.json": [
		5892,
		5892
	],
	"./fr/search.json": [
		23961,
		3961
	],
	"./fr/settings.json": [
		46658,
		6658
	],
	"./fr/sidebar.json": [
		25725,
		5725
	],
	"./fr/workload.json": [
		66538,
		6538
	],
	"./pt/auth.json": [
		84805,
		4805
	],
	"./pt/cluster.json": [
		63617,
		3617
	],
	"./pt/configmap.json": [
		90823,
		823
	],
	"./pt/crd.json": [
		45674,
		5674
	],
	"./pt/frequent.json": [
		86781,
		6781
	],
	"./pt/glossary.json": [
		85795,
		5795
	],
	"./pt/hpa.json": [
		68312,
		8312
	],
	"./pt/ingress.json": [
		36967,
		6967
	],
	"./pt/logs.json": [
		87055,
		7055
	],
	"./pt/node.json": [
		18322,
		8322
	],
	"./pt/notification.json": [
		91325,
		1325
	],
	"./pt/notifications.json": [
		95048,
		5048
	],
	"./pt/pdb.json": [
		27624,
		7624
	],
	"./pt/priorityClasses.json": [
		69013,
		9013
	],
	"./pt/release.json": [
		17058,
		7058
	],
	"./pt/resource.json": [
		91107,
		1107
	],
	"./pt/resourceQuota.json": [
		26643,
		6643
	],
	"./pt/role.json": [
		97675,
		7675
	],
	"./pt/search.json": [
		82236,
		2236
	],
	"./pt/settings.json": [
		11635,
		1635
	],
	"./pt/sidebar.json": [
		42376,
		2376
	],
	"./pt/workload.json": [
		57659,
		7659
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10471;
module.exports = webpackAsyncContext;